import { useLayoutEffect, useRef } from 'react';
import { ReactComponent as ScotlandScriptSvg } from './assets/we-hope-to-see-you-in-Scotland-x.svg';

/**
 * Inline SVG with per-path stroke-dash “draw” then fill fade — approximates handwriting
 * on filled glyph outlines (not true pen strokes).
 */
export function SplashScotlandScript() {
  const wrapRef = useRef(null);

  useLayoutEffect(() => {
    const svg = wrapRef.current?.querySelector('svg');
    if (!svg) return;

    const paths = svg.querySelectorAll('path');
    let delay = 0;
    const stagger = 0.055;
    const minDur = 0.35;
    const maxDur = 1.35;
    const lenScale = 520;

    paths.forEach((path) => {
      const len = path.getTotalLength();
      const duration = Math.min(maxDur, minDur + len / lenScale);
      path.style.setProperty('--path-len', String(len));
      path.style.setProperty('--write-dur', `${duration}s`);
      path.style.animationDelay = `${delay}s`;
      delay += stagger + duration * 0.12;
    });
  }, []);

  return (
    <div
      ref={wrapRef}
      className="splash-script splash-script--handwriting splash-entrance splash-entrance--script"
      role="img"
      aria-label="We hope to see you in Scotland"
    >
      <ScotlandScriptSvg className="splash-script-svg" focusable="false" aria-hidden="true" />
    </div>
  );
}
